<template>
  <v-footer height="54" app :order="-1" :class="footerClass">
    <span style="font-family: Orbitron; font-size: 10pt">cynque&nbsp;</span>
    <span>&copy; {{ new Date().getFullYear() }}</span>
    <span class="text-grey">&nbsp;&nbsp; {{ $config.public.version }}</span>
    <v-spacer />
    <FooterPlusSignMenu />
  </v-footer>
</template>

<script>
import { isDarkTheme } from '~/cynqueModules/nuxtAccessors'

export default {
  data() {
    return {
      mn: '[components/defaultLayout/Footer.vue]',
    }
  },
  computed: {
    // Restore the footer to V2 parity under Vuetify 3:
    // - :order="-1" (on the <v-footer app> above) makes the footer claim the full bottom
    //   edge ahead of the nav drawer, so it runs to the left edge (left 0, full width) and
    //   the drawer shortens to sit above it -- exactly as in V2. Without it the drawer keeps
    //   full height and insets the footer to the drawer's right edge (left 271).
    // - Light mode gets V2's grey footer (#f5f5f5 = grey-lighten-4). Dark mode falls
    //   through to the default theme surface, mirroring the nav drawer's convention
    //   (see navDrawerClass in layouts/default.vue).
    footerClass() {
      return isDarkTheme() ? '' : 'bg-grey-lighten-4'
    },
  },
}
</script>
